import React, {Component} from 'react';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import {UnitPrettifier} from "../../../../core/prettifier/UnitPrettifier";
import {Checkbox, Collapse, FormControlLabel} from "@mui/material";
import {UrlBuilder} from "../../../../core/url/UrlBuilder";
import moment from "moment";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import DialogContentText from "@mui/material/DialogContentText";
import {HoursMinutesTimeConverter} from "../../../../core/prettifier/HoursMinutesTimeConverter";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {DatePicker, LocalizationProvider, TimePicker} from "@mui/lab";
import Slide from "@mui/material/Slide";
import {ExerciseType} from "../../../../core/models/ExerciseType";
import {ExerciseGoalType} from "../../../../core/models/ExerciseGoalType";
import Box from "@mui/material/Box";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

class GoalNewOrEditFormPopUp extends Component {
	constructor(props) {
		super(props);
		this.state = {
			exercise: this.props.exercise,
			goal: this.props.goal,
			isOpen: this.props.isOpen,
			selectedGoalTypeId: this.props.goal ? this.props.goal.type.id : null,
			deadline: this.props.goal && this.props.goal.deadline ? this.props.goal.deadline : null,
			value1: this.props.goal ? this.props.goal.value1 : 0,
			value2: this.props.goal ? this.props.goal.value2 : 0,
			description: this.props.goal ? this.props.goal.description : '',
			isRoutineSpecific: this.props.goal && this.props.goal.routineExerciseId ? this.props.goal.routineExerciseId : false,
			isLoading: false,
		};
	}

	componentWillReceiveProps(nextProps, nextContext) {
		this.setState({
			exercise: nextProps.exercise,
			goal: nextProps.goal,
			isOpen: nextProps.isOpen,
			selectedGoalTypeId: nextProps.goal ? nextProps.goal.type.id : null,
			deadline: nextProps.goal && nextProps.goal.deadline ? nextProps.goal.deadline : null,
			value1: nextProps.goal ? (nextProps.goal.values[0] ?? 0) : 0,
			value2: nextProps.goal ? (nextProps.goal.values[1] ?? 0) : 0,
			description: nextProps.goal ? nextProps.goal.description : '',
			isRoutineSpecific: nextProps.goal && nextProps.goal.routineExerciseId ? nextProps.goal.routineExerciseId : false,
			isDeleteConfirmationDialogOpen: false,
		});
	}

	updateSelectedGoalTypeIdFromDropdownInputSelection = (event) => {
		this.setState({
			selectedGoalTypeId: event.target.value,
			value1: 0,
			value2: 0,
		});
	}

	updateStateInputValues = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	updateRoutineSpecificCheckboxInputValue = (e) => {
		this.setState({
			isRoutineSpecific: e.target.checked,
		});
	}

	handleDateChange = (date) => {
		this.setState({ deadline: date });
	}

	submitWithEnter = (e) => {
		if (e.key === 'Enter' && !this.state.isLoading) {
			this.submit(e);
		}
	}

	submit = async (event) => {
		event.preventDefault();

		this.setState({ isLoading: true });

		let exerciseGoalToSave;
		if (this.state.goal) {
			exerciseGoalToSave = {
				id: this.state.goal.id,
				routineExerciseId: this.state.isRoutineSpecific ? this.state.exercise.routineExerciseId : null,
				description: this.state.description,
				deadline: this.state.deadline ? moment(this.state.deadline).format('L, h:mm:ss A') : null,
				dateModified: moment().format('L, h:mm:ss A'),
			};
		} else {
			exerciseGoalToSave = {
				type: { id: this.state.selectedGoalTypeId },
				exerciseId: this.state.exercise.id,
				routineExerciseId: this.state.isRoutineSpecific ? this.state.exercise.routineExerciseId : null,
				description: this.state.description,
				deadline: this.state.deadline ? moment(this.state.deadline).format('L, h:mm:ss A') : null,
				dateCreated: moment().format('L, h:mm:ss A'),
			};
		}

		let values = [this.state.value1];
		if (this.state.value2) {
			values.push(this.state.value2);
		}
		exerciseGoalToSave['values'] = values;

		await fetch(UrlBuilder.goals.exerciseGoalsApi(), {
			method: this.state.goal ? 'PUT' : 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(exerciseGoalToSave)
		}).then(() => this.props.closeSelfFunc(true));

		this.setState({ isLoading: false });
	}

	openGoalDeleteConfirmationDialog = (isOpen) => {
		this.setState({ isDeleteConfirmationDialogOpen: isOpen });
	}

	renderDeleteConfirmationDialog = () => {
		if (!this.state.goal || !this.state.isDeleteConfirmationDialogOpen) return null;

		return (
			<Dialog open={true} onClose={() => this.openGoalDeleteConfirmationDialog(false)} TransitionComponent={Transition}>
				<DialogTitle>Delete this goal?</DialogTitle>
				<DialogContent>
					<DialogContentText>
						This cannot be undone.
					</DialogContentText>
				</DialogContent>
				<DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
					<Button variant="outlined" onClick={() => this.openGoalDeleteConfirmationDialog(false)} sx={{ textTransform: 'none' }}>
						Cancel
					</Button>
					<Button variant="contained" onClick={(e) => this.props.deleteGoalFunc(e, this.state.goal)} color="error" sx={{ textTransform: 'none', fontWeight: 600 }}>
						Delete
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	renderGoalTypesMenu = () => {
		const typeId = this.state.exercise.type.id;
		const isEditing = !!this.state.goal;

		const options = {
			[ExerciseType.WeightAndReps]: [
				{ value: ExerciseGoalType.WeightAndRepsGoal, label: 'Weight & Reps' },
				{ value: ExerciseGoalType.WeightGoal, label: 'Weight' },
				{ value: ExerciseGoalType.RepsGoal, label: 'Reps' },
			],
			[ExerciseType.Reps]: [
				{ value: ExerciseGoalType.RepsGoal, label: 'Reps' },
			],
			[ExerciseType.DistanceAndTime]: [
				{ value: ExerciseGoalType.DistanceAndTimeGoal, label: 'Distance & Time' },
				{ value: ExerciseGoalType.DistanceGoal, label: 'Distance' },
				{ value: ExerciseGoalType.TimeGoal, label: 'Time' },
			],
			[ExerciseType.Time]: [
				{ value: ExerciseGoalType.TimeGoal, label: 'Time' },
			],
			[ExerciseType.WeightAndTime]: [
				{ value: ExerciseGoalType.WeightAndTimeGoal, label: 'Weight & Time' },
				{ value: ExerciseGoalType.WeightGoal, label: 'Weight' },
				{ value: ExerciseGoalType.TimeGoal, label: 'Time' },
			],
		};

		return (
			<Select
				value={this.state.selectedGoalTypeId ?? ''}
				onChange={this.updateSelectedGoalTypeIdFromDropdownInputSelection}
				disabled={isEditing}
				size="small"
			>
				{(options[typeId] || []).map(opt => (
					<MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
				))}
			</Select>
		);
	}

	renderTextField = (label, key, unitLabel = null) => (
		<TextField
			variant="outlined"
			margin="dense"
			type="number"
			inputMode="decimal"
			required
			size="small"
			error={this.state[key] < 0}
			name={key}
			value={this.state[key]}
			label={label}
			InputProps={{
				endAdornment: unitLabel ? <InputAdornment position="end">{unitLabel}</InputAdornment> : null,
			}}
			onChange={this.updateStateInputValues}
			onKeyPress={this.submitWithEnter}
			sx={{ maxWidth: 160 }}
			disabled={this.state.goal && this.state.goal.dateCompleted}
		/>
	)

	updateTimeAttributeValue = (key, val) => {
		this.setState({
			[key]: HoursMinutesTimeConverter.convertDateStringToFloat(val),
		});
	}

	renderTimeField = (label, key) => (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<TimePicker
				ampm={false}
				openTo="minutes"
				views={["hours", "minutes", "seconds"]}
				inputFormat="HH:mm:ss"
				label={label}
				value={HoursMinutesTimeConverter.convertFloatToDateTime(this.state[key])}
				onChange={(val) => this.updateTimeAttributeValue(key, val)}
				disabled={this.state.goal && this.state.goal.dateCompleted}
				renderInput={(params) => <TextField {...params} size="small" sx={{ maxWidth: 160 }} />}
			/>
		</LocalizationProvider>
	)

	renderGoalTypeValues = () => {
		switch (this.state.selectedGoalTypeId) {
			case ExerciseGoalType.WeightAndRepsGoal:
				return <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
					{this.renderTextField('Weight', 'value1', UnitPrettifier.weight())}
					{this.renderTextField('Reps', 'value2', 'reps')}
				</Box>;
			case ExerciseGoalType.WeightGoal:
				return this.renderTextField('Weight', 'value1', UnitPrettifier.weight());
			case ExerciseGoalType.RepsGoal:
				return this.renderTextField('Reps', 'value1', 'reps');
			case ExerciseGoalType.DistanceAndTimeGoal:
				return <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
					{this.renderTextField('Distance', 'value1', UnitPrettifier.distance())}
					{this.renderTimeField('Time', 'value2')}
				</Box>;
			case ExerciseGoalType.DistanceGoal:
				return this.renderTextField('Distance', 'value1', UnitPrettifier.distance());
			case ExerciseGoalType.TimeGoal:
				return this.renderTimeField('Time', 'value1');
			case ExerciseGoalType.WeightAndTimeGoal:
				return <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
					{this.renderTextField('Weight', 'value1', UnitPrettifier.weight())}
					{this.renderTimeField('Time', 'value2')}
				</Box>;
			default:
				return null;
		}
	}

	render() {
		const isCompleted = this.state.goal && this.state.goal.dateCompleted;

		return (
			<Dialog
				open={this.state.isOpen}
				onClose={() => this.props.closeSelfFunc(false)}
				fullWidth
				TransitionComponent={Transition}
				PaperProps={{ sx: { borderRadius: 3 } }}
			>
				<DialogTitle sx={{ pb: 1 }}>
					<Typography variant="h6" sx={{ fontWeight: 600 }}>
						{this.state.goal ? 'Edit Goal' : 'Create Goal'}
					</Typography>
					{isCompleted && (
						<Typography variant="caption" sx={{ color: 'success.main', fontWeight: 500 }}>
							Completed on {moment(this.state.goal.dateCompleted).format('DD/MM/YYYY')}
						</Typography>
					)}
				</DialogTitle>

				<DialogContent sx={{ pt: 2 }}>
					{/* Goal Type */}
					<Box sx={{ mb: 2.5 }}>
						<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11, display: 'block', mb: 1 }}>
							Goal Type
						</Typography>
						<FormControl fullWidth variant="outlined" size="small">
							{this.renderGoalTypesMenu()}
						</FormControl>
					</Box>

					<Collapse in={this.state.selectedGoalTypeId !== null}>
						{/* Target Values */}
						<Box sx={{ mb: 2.5 }}>
							<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11, display: 'block', mb: 1 }}>
								Target
							</Typography>
							{this.renderGoalTypeValues()}
						</Box>

						{/* Deadline & Description */}
						<Box sx={{ mb: 2.5 }}>
							<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11, display: 'block', mb: 1 }}>
								Details
							</Typography>
							<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
								<LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										variant="inline"
										inputFormat="dd/MM/yyyy"
										name="deadline"
										label="Deadline (optional)"
										value={this.state.deadline}
										disabled={isCompleted}
										onChange={this.handleDateChange}
										renderInput={(params) => <TextField {...params} size="small" fullWidth />}
									/>
								</LocalizationProvider>
								<TextField
									margin="dense"
									name="description"
									label="Description (optional)"
									type="text"
									size="small"
									fullWidth
									onChange={this.updateStateInputValues}
									value={this.state.description}
									onKeyPress={this.submitWithEnter}
								/>
							</Box>
						</Box>

						{/* Routine-specific toggle */}
						<Box sx={{
							bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
							borderRadius: 2,
							px: 2,
							py: 1.5,
						}}>
							<FormControlLabel
								control={
									<Checkbox
										checked={this.state.isRoutineSpecific}
										onChange={this.updateRoutineSpecificCheckboxInputValue}
										color="secondary"
										disabled={isCompleted}
										size="small"
									/>
								}
								label={<Typography variant="body2" sx={{ fontWeight: 500 }}>Routine-specific</Typography>}
							/>
							<Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, mt: 0.5 }}>
								<InfoOutlinedIcon sx={{ fontSize: 14, color: 'text.disabled', mt: 0.25 }} />
								<Typography variant="caption" sx={{ color: 'text.disabled', lineHeight: 1.4 }}>
									{this.state.isRoutineSpecific
										? 'This goal only tracks progress within this routine.'
										: 'This goal tracks progress across all routines with this exercise.'
									}
								</Typography>
							</Box>
						</Box>
					</Collapse>

					{this.renderDeleteConfirmationDialog()}
				</DialogContent>

				<DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
					{this.state.goal && (
						<IconButton onClick={() => this.openGoalDeleteConfirmationDialog(true)} size="small" sx={{ color: 'error.main' }}>
							<DeleteIcon sx={{ fontSize: 20 }} />
						</IconButton>
					)}

					<Box sx={{ flex: 1 }} />

					<Button
						variant="outlined"
						onClick={() => this.props.closeSelfFunc(false)}
						sx={{ textTransform: 'none', fontWeight: 500 }}
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						color="secondary"
						onClick={this.submit}
						disabled={this.state.isLoading || this.state.selectedGoalTypeId === null || !this.state.value1}
						sx={{ textTransform: 'none', fontWeight: 600, px: 3 }}
					>
						{this.state.isLoading ? (
							<><CircularProgress size={16} color="inherit" sx={{ mr: 1 }} /> Saving...</>
						) : (
							'Save'
						)}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

export default GoalNewOrEditFormPopUp;
